import {
  BigBlueArrowLeft, Button, CurrentTimeLine, MeetingPlanerSchedule, MeetingViewModel,
  MessageDialogViewModel, PageWrapper, SmallArrowLeft, SmallArrowRight
} from '@components';
import { marginTopForMeetingPlaner, useStore, useViewModel } from '@utils';
import { observer } from 'mobx-react-lite';
import React, { FC, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { MembersStore } from '../../store';
import { MeetingPlanerViewModel } from './MeetingPlanerViewModel';
import '../../styles/views/meetingPlannerPage/meetingPlannerPage.scss';

export const MeetingPlanerPage: FC = observer(() => {
  const messageDialogViewModel = useViewModel(MessageDialogViewModel);
  const meetingPlanerViewModel = useViewModel(MeetingPlanerViewModel);
  const meetingViewModel = useViewModel(MeetingViewModel);
  const membersStore = useStore(MembersStore);
  const navigate = useNavigate();

  useEffect(() => {
    meetingPlanerViewModel.getAllMeetingsByUsers();
    sessionStorage.removeItem('filter');
    !membersStore.data.length && membersStore.getMembers();
  }, [meetingPlanerViewModel.selectedMembers.size]);

  useEffect(() => {
    return () => {
      meetingPlanerViewModel.clearMembers();
      meetingPlanerViewModel.clearDate();
      meetingPlanerViewModel.clearMeetings();
    };
  }, [])

  const resetMeetings = () => {
    meetingPlanerViewModel.clearMembers();
    meetingPlanerViewModel.setMembers(meetingViewModel.meetingData.members, undefined);
    meetingPlanerViewModel.saveMembers();
    navigate('/');
  };

  const moveToPrevCalendarData = () => {
    meetingPlanerViewModel.moveDate('prev');
  };

  const moveToNextCalendarData = () => {
    meetingPlanerViewModel.moveDate('next');
  };

  const onSave = () => {
    meetingPlanerViewModel.saveDate();
    meetingPlanerViewModel.saveMembers();
    meetingPlanerViewModel.saveTime();

    navigate('/');
  };

  const showSaveDialog = () => {
    messageDialogViewModel.open({
      message: 'Сохранить изменения в планировщике?',
      isPlaner: true,
      onAccept: onSave,
      onReject: resetMeetings,
    });
  };

  return (
    <PageWrapper>
      <div className="meeting-planer">
        <CurrentTimeLine marginTop={marginTopForMeetingPlaner} />
        <div className="header">
          <BigBlueArrowLeft onClick={showSaveDialog} />
          <div className="date-planner">
            <Button
              icon={<SmallArrowLeft />}
              className="soft move-in-calendar-button"
              onClick={moveToPrevCalendarData}
              disabled={meetingPlanerViewModel.isDayActive(meetingPlanerViewModel.date)}
            />
            <div className="current-date">
              {meetingPlanerViewModel.title}
            </div>
            <Button
              icon={<SmallArrowRight />}
              className="soft move-in-calendar-button"
              onClick={moveToNextCalendarData}
            />
          </div>
          <Link to={'/'}>
            <Button
              title='Сохранить'
              className='medium-short'
              onClick={onSave}
            />
          </Link>
        </div>
        <MeetingPlanerSchedule />
      </div >
    </PageWrapper>
  );
});
